import { useMemo } from 'react';
import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { useShowCampaignGroupTooltip } from 'modules/campaigns/hooks';
import { ENTITY, ENTITY_TO_PATH_MAP } from '../config';
import { useCreateCampaignGroupTooltip } from './useCreateCampaignGroupTooltip';

const TOOLTIP_CONDITIONS = {
    [ENTITY_TO_PATH_MAP[ENTITY.CAMPAIGN]]: true,
    campaignOnboarding: true,
};

export const useOptionsWithTooltip = rawOptions => {
    const shouldShowTooltip = useShowCampaignGroupTooltip();
    const { tooltipContent, tooltipOptions } = useCreateCampaignGroupTooltip();
    const optionsWithTooltip = useMemo(() => {
        return rawOptions.map(option => {
            if (TOOLTIP_CONDITIONS[option.value] && shouldShowTooltip) {
                return {
                    ...option,
                    label: (
                        <TooltipWrapper wrap tooltipContent={tooltipContent} tooltipOptions={tooltipOptions}>
                            <div data-tooltip-option="true">{option.label}</div>
                        </TooltipWrapper>
                    ),
                };
            }
            return option;
        });
    }, [rawOptions, shouldShowTooltip, tooltipContent, tooltipOptions]);

    return optionsWithTooltip;
};
